import _ from 'lodash';

export function groupTimeslotExceptions(timeslots, timeslotKinds) {
	const groups = {};
	for( const slot of _.sortBy(timeslots, ['timeslot_day', 'timeslot_start']) ) {
		const kindRecord = _.find(timeslotKinds, ( kind ) => {
			return kind.kind === slot.kind?.toLowerCase() && kind.sub_kind === slot.sub_kind?.toLowerCase();
		});
		for( const exception of slot.timeslot_exceptions ?? [] ) {
			if( !groups[exception.group_identifier] ) {
				groups[exception.group_identifier] = {
					..._.pick(exception, ['group_identifier', 'name', 'kind', 'date_start', 'date_end', 'comment', 'active']),
					timeslots: [],
					exceptions: [],
				};
			}
			groups[exception.group_identifier].exceptions.push(exception);
			groups[exception.group_identifier].timeslots.push({ ...slot, kind_record: kindRecord });
		}
	}
	return _.sortBy(groups, ['status', 'date_start', 'date_end']);
}
